<script setup></script>

<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 10px; transform: translateY(-1px);" fill="currentColor">
		<circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5" fill="none" />
		<rect x="7.25" y="6.5" width="1.5" height="5.5" rx="0.25" />
		<rect x="7.25" y="4" width="1.5" height="1.5" rx="0.25" />
	</svg>
</template>
<style></style>
